import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  Table,
  Input,
  Typography,
  Select,
  Switch,
  Space,
  Row,
  Col,
  Tooltip,
  Layout,
  Popconfirm,
  message,
  Radio,
  PageHeader,
  Popover,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import {
  getWorkspaceChannelSync,
  deleteChannelSync,
  updateChannelSync,
  getChannelList,
  updateSkill,
} from '../skills_action';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AutoChannelSync from './AutoChannelSync';
import queryString from 'query-string';

const { Option } = Select;
const { Text } = Typography;
const { Search } = Input;
const { Content } = Layout;

const ChannelSync = (props) => {
  const {
    // getProject,
    // issues,
    // isAdmin,
    // getIssues,
    // skills,
    // members,
    // team,
    // user_now,
    skill,
    // dropDownSearchJiraProjects,
    match: {
      params: { wId, sub_skill, skill_id },
    },
  } = props;
  const dispatch = useDispatch();
  const jiraSkill =
    skill && skill.skill_metadata ? skill.skill_metadata : skill;
  let parsed_query = queryString.parse(props.location.search);

  const user_now = useSelector((store) => store.common_reducer.user);
  const channels = useSelector((store) => store.skills.channels);
  const isWorkspaceAdmin = useSelector((store) => store.common_reducer.isAdmin);
  const team = useSelector((store) => store.skills.team);
  const isJiraAdmin = jiraSkill.jiraConnectedId === user_now._id;
  const accessToEdit = isWorkspaceAdmin || isJiraAdmin;
  const teamId = team.id;

  const [channelSyncs, set_channelSyncs] = useState([]);
  const [channelSyncsLoading, set_channelSyncsLoading] = useState(false);
  const [channelSyncSearchText, set_channelSyncSearchText] = useState('');

  const type_of_task = sub_skill === 'jira_service_desk' ? 'request' : 'issue';
  const type_of_task_upper_case =
    sub_skill === 'jira_service_desk' ? 'Request' : 'Issue';

  useEffect(() => {
    set_channelSyncsLoading(true);
    getWorkspaceChannelSync(wId, sub_skill).then((res) => {
      if (res && res.data && res.data.success) {
        if (res.data.channelSyncs) set_channelSyncs(res.data.channelSyncs);
        set_channelSyncsLoading(false);
      }
    });

    if (channels.length === 0) {
      dispatch(getChannelList(wId));
    }
  }, []);

  const handleDeleteChannelSync = (channel_sync_id, channelSync) => {
    deleteChannelSync(wId, channel_sync_id).then((res) => {
      if (res.data.success) {
        let temp = [];
        channelSyncs.forEach((cs) => {
          if (cs._id !== channel_sync_id) temp.push(cs);
        });
        set_channelSyncs(temp);

        if (!res.data.deletedChannelSync)
          message.error('Channel sync not found');
      }
    });
  };

  const handleUpdate = (checked, channelSync) => {
    updateChannelSync(wId, channelSync._id, { isDeSynced: !checked }).then(
      (res) => {
        if (res.data.success && res.data.updatedChannelSync) {
          set_channelSyncs(
            channelSyncs.map((cs) =>
              cs._id === channelSync._id ? res.data.updatedChannelSync : cs
            )
          );
        } else message.error('Channel sync not found');
      }
    );
  };

  const columns = [
    {
      title: 'Channel Name',
      dataIndex: 'channel_name',
      key: 'channel_name',
      ellipsis: {
        showTitle: false,
      },
      width: 300,
      render: (channel_name, channelSync) => (
        <Button
          type='link'
          target={'_blank'}
          href={`https://slack.com/app_redirect?team=${teamId}&channel=${channelSync.channel}`}
        >
          #{channel_name || channelSync.channel}
        </Button>
      ),
    },
    {
      title: 'Jira Issue',
      dataIndex: 'task_key',
      key: 'task_key',
    },
    {
      title: (
        <div>
          Status
          <Tooltip title='Pause or resume syncing in this channel'>
            <InfoCircleOutlined style={{ marginLeft: 8 }} />
          </Tooltip>
        </div>
      ),
      key: 'isDeSynced',
      dataIndex: 'isDeSynced',
      render: (isDeSynced, channelSync) => (
        <Switch
          checked={isDeSynced ? false : true}
          onChange={(checked) => handleUpdate(checked, channelSync)}
        />
      ),
    },
    {
      title: 'Action',
      key: 'action',
      dataIndex: '_id',
      render: (channel_sync_id, channelSync) => (
        <Space size='middle'>
          <Popconfirm
            title={`This action will disable and delete Channel Sync in #${
              channelSync.channel_name || channelSync.channel
            } with Jira issue ${channelSync.task_key}. Are you sure?`}
            onConfirm={() =>
              handleDeleteChannelSync(channel_sync_id, channelSync)
            }
            okText='Delete'
            okType='danger'
            cancelText='No'
          >
            <Button type='link'>Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const getChannelSyncTableData = () => {
    if (channels.length === 0) return [];
    let channelSyncsWithAccess = [];
    channelSyncs.forEach((cs) => {
      if (channels.find((channel) => channel.id === cs.channel))
        channelSyncsWithAccess.push(cs);
      else if (accessToEdit) {
        cs.channel_name = cs.channel; // CHANNEL ID
        channelSyncsWithAccess.push(cs);
      }
    });
    return channelSyncsWithAccess;
  };

  const handleChannelSyncDefaultChange = (value, valuekey) => {
    let sub_skill = props.match.params.sub_skill;
    let channelSyncDefault = {
      type: '2_way',
      update_type: 'all_updates',
      dont_add_all_participants_to_channel: false,
      archive_channel_on_closed_ticket: false,
    };

    if (sub_skill === 'jira_service_desk') {
      if (jiraSkill.global_helpdesk_channelsync_default)
        channelSyncDefault = jiraSkill.global_helpdesk_channelsync_default;
    } else if (sub_skill === 'jira_software') {
      if (jiraSkill.global_project_channelsync_default)
        channelSyncDefault = jiraSkill.global_project_channelsync_default;
    }

    if (valuekey === 'type') {
      channelSyncDefault.type = value;
    } else if (valuekey === 'update_type') {
      channelSyncDefault.update_type = value;
    } else if (
      valuekey === 'dont_add_all_participants_to_channel' &&
      sub_skill === 'jira_service_desk'
    ) {
      channelSyncDefault.dont_add_all_participants_to_channel = !value;
    } else if (valuekey === 'archive_channel_on_closed_ticket') {
      channelSyncDefault.archive_channel_on_closed_ticket = value;
    }

    updateSkillData(
      sub_skill === 'jira_service_desk'
        ? { global_helpdesk_channelsync_default: channelSyncDefault }
        : {
            global_project_channelsync_default: channelSyncDefault,
          }
    );
  };

  const updateSkillData = (data) => {
    dispatch(
      updateSkill(props.match.params.skill_id, props.match.params.wId, data)
    );
  };

  return (
    <div style={{ maxHeight: '100vh', minHeight: '100vh' }}>
      {parsed_query && parsed_query.acs_edit ? (
        ''
      ) : (
        <PageHeader title='Channel Sync' />
      )}
      <Content
        style={{ height: 'calc(100vh - 72px)', overflow: 'scroll' }}
        className='main-content-padding'
      >
        <Row gutter={[16, 16]}>
          {parsed_query && parsed_query.acs_edit ? (
            ''
          ) : (
            <>
              <Col span={24} id='channelsync_defaults'>
                <Card
                  title={
                    <>
                      <Text>New Channel Sync Defaults</Text>
                    </>
                  }
                  key='2'
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>
                      <Radio.Group
                        disabled={isWorkspaceAdmin ? false : true}
                        onChange={(event) => {
                          handleChannelSyncDefaultChange(
                            event.target.value,
                            'type'
                          );
                        }}
                        value={
                          sub_skill === 'jira_service_desk'
                            ? jiraSkill &&
                              jiraSkill.global_helpdesk_channelsync_default
                              ? jiraSkill.global_helpdesk_channelsync_default
                                  .type
                              : '2_way'
                            : jiraSkill &&
                              jiraSkill.global_project_channelsync_default
                            ? jiraSkill.global_project_channelsync_default.type
                            : '2_way'
                        }
                      >
                        <Space direction='vertical'>
                          <Radio value={'2_way'}>
                            <Text strong>2 way sync</Text> - all Slack messages
                            will be added as {type_of_task} comments and all{' '}
                            {type_of_task} updates will be posted to channel
                          </Radio>
                          <Radio value={'jira_to_slack'}>
                            <Text strong>1-way sync from Jira to Slack</Text> -
                            post {type_of_task} updates to this channel
                            {/* <Tooltip title={<>With the 1-way sync option, you can manually sync
                          selected Slack messages by adding 💬
                          (:speech_balloon:) emoji. See emoji actions configured
                          for your workspace{' '}
                          <a
                            onClick={() =>
                              props.history.push(
                                `/${props.match.params.wId}/emoji_actions`
                              )
                            }
                          >
                            here
                          </a>
                          . You can also search and use Troopr's message action
                          'Comment it' under the ellipsis menu of the message.</>}>
                            <InfoCircleOutlined style={{ marginLeft: 8 }} />
                          </Tooltip> */}
                            <Popover
                              style={{ width: 200 }}
                              content={
                                <>
                                  With the 1-way sync option, you
                                  <br />
                                  can manually sync selected Slack
                                  <br />
                                  messages by adding 💬
                                  <br />
                                  (:speech_balloon:) emoji. See emoji
                                  <br />
                                  actions configured for your
                                  <br />
                                  workspace{' '}
                                  <a
                                    onClick={() =>
                                      props.history.push(
                                        `/${props.match.params.wId}/emoji_actions`
                                      )
                                    }
                                  >
                                    here
                                  </a>
                                  . You can also
                                  <br />
                                  search and use Troopr's message
                                  <br />
                                  action 'Comment it' under the
                                  <br />
                                  ellipsis menu of the message.
                                </>
                              }
                            >
                              <InfoCircleOutlined style={{ marginLeft: 8 }} />
                            </Popover>
                          </Radio>
                          <Radio value={'no_sync'}>
                            <Text strong>No sync</Text>
                          </Radio>
                        </Space>
                      </Radio.Group>
                    </div>
                  </div>
                  <br />
                  {(
                    sub_skill === 'jira_service_desk'
                      ? jiraSkill &&
                        jiraSkill.global_helpdesk_channelsync_default &&
                        jiraSkill.global_helpdesk_channelsync_default.type ===
                          'no_sync'
                      : jiraSkill &
                          jiraSkill.global_project_channelsync_default &&
                        jiraSkill.global_project_channelsync_default.type ===
                          'no_sync'
                  ) ? (
                    ''
                  ) : (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <div>
                          <Text type='secondary'>
                            Only these Jira {type_of_task} updates will be
                            posted to Slack channel sync.
                          </Text>
                        </div>
                        <div style={{ width: '20%', marginLeft: '24px' }}>
                          <Select
                            style={{ width: '100%' }}
                            disabled={isWorkspaceAdmin ? false : true}
                            value={
                              sub_skill === 'jira_service_desk'
                                ? jiraSkill &&
                                  jiraSkill.global_helpdesk_channelsync_default
                                  ? jiraSkill
                                      .global_helpdesk_channelsync_default
                                      .update_type
                                  : 'all_updates'
                                : jiraSkill &&
                                  jiraSkill.global_project_channelsync_default
                                ? jiraSkill.global_project_channelsync_default
                                    .update_type
                                : 'all_updates'
                            }
                            placeholder='select a product'
                            onChange={(value) =>
                              handleChannelSyncDefaultChange(
                                value,
                                'update_type'
                              )
                            }
                          >
                            {[
                              { label: 'All updates', value: 'all_updates' },
                              {
                                label: 'Comments & Status',
                                value: 'comment_status',
                              },
                              { label: 'Status', value: 'status' },
                              { label: 'Comments', value: 'comment' },
                              { label: 'None', value: 'none' },
                            ].map((o, key) => (
                              <Option key={key} value={o.value}>
                                {' '}
                                {o.label}{' '}
                              </Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                      <br />
                    </>
                  )}
                  {sub_skill === 'jira_service_desk' && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div>
                        <Text type='secondary'>
                          All participants should be members of the channel
                          <Tooltip title='Users from following user fields will be added automatically: Assignee, Reporter, Request Participants, Watchers. if disabled only Assignee and Reporter will be added to the channel'>
                            <InfoCircleOutlined style={{ marginLeft: 8 }} />
                          </Tooltip>
                        </Text>
                      </div>
                      <div>
                        <Switch
                          checked={
                            jiraSkill &&
                            jiraSkill.global_helpdesk_channelsync_default &&
                            jiraSkill.global_helpdesk_channelsync_default
                              .dont_add_all_participants_to_channel
                              ? false
                              : true
                          }
                          onChange={(value) =>
                            handleChannelSyncDefaultChange(
                              value,
                              'dont_add_all_participants_to_channel'
                            )
                          }
                        />
                      </div>
                    </div>
                  )}
                  <Row
                    justify='space-between'
                    align='middle'
                    style={{
                      paddingTop: sub_skill === 'jira_service_desk' && '1.5rem',
                    }}
                  >
                    <Text type='secondary'>
                      Archive channel when done
                      <Tooltip title='Auto archives the channel when the JIRA ticket with which it is syncing is set to CLOSED status'>
                        <InfoCircleOutlined style={{ marginLeft: 8 }} />
                      </Tooltip>
                    </Text>
                    <Switch
                      checked={
                        sub_skill === 'jira_service_desk'
                          ? jiraSkill &&
                            jiraSkill.global_helpdesk_channelsync_default &&
                            jiraSkill.global_helpdesk_channelsync_default
                              .archive_channel_on_closed_ticket
                          : jiraSkill &&
                            jiraSkill.global_project_channelsync_default &&
                            jiraSkill.global_project_channelsync_default
                              .archive_channel_on_closed_ticket
                      }
                      onChange={(value) =>
                        handleChannelSyncDefaultChange(
                          value,
                          'archive_channel_on_closed_ticket'
                        )
                      }
                    />
                  </Row>
                </Card>
              </Col>
              <Col span={24}>
                <Card
                  id='tpgp-um'
                  title={
                    <>
                      <span>Channel Sync Channels</span>
                      <Tooltip
                        title={`Channel Sync Channel is actively syncing conversations in the channel to a configured Jira issue. ${
                          team &&
                          team.bot &&
                          team.bot.meta &&
                          team.bot.meta.enterprise &&
                          team.bot.meta.enterprise.id
                            ? 'Channel sync will only work in the workspace where channel sync is created in grid'
                            : ''
                        }`}
                      >
                        <InfoCircleOutlined style={{ marginLeft: 8 }} />
                      </Tooltip>
                    </>
                  }
                >
                  <Space style={{ marginBottom: 16 }}>
                    <Search
                      // autoFocus
                      allowClear={true}
                      placeholder='start typing'
                      style={{ width: 200 }}
                      onSearch={(value) => set_channelSyncSearchText(value)}
                    />

                    {/* <Button>New Channel Sync</Button> */}
                  </Space>
                  <Table
                    columns={columns}
                    dataSource={
                      channelSyncSearchText
                        ? getChannelSyncTableData().filter(
                            (cs) =>
                              (cs.channel_name &&
                                cs.channel_name
                                  .toLowerCase()
                                  .includes(
                                    channelSyncSearchText.toLowerCase()
                                  )) ||
                              cs.channel
                                .toLowerCase()
                                .includes(
                                  channelSyncSearchText.toLowerCase()
                                ) ||
                              cs.task_key
                                .toLowerCase()
                                .includes(channelSyncSearchText.toLowerCase())
                          )
                        : getChannelSyncTableData()
                    }
                    pagination={{ defaultPageSize: 4, size: 'small' }}
                    loading={channelSyncsLoading || channels.length === 0}
                  />
                </Card>
              </Col>
            </>
          )}
          <Col span={24}>
            <AutoChannelSync skill={props.skill} />
          </Col>
        </Row>
      </Content>
    </div>
  );
};

export default withRouter(ChannelSync);
